<app-links-item>
  <div app-links-item-content-description>
    <span class="font-small mr-2" [ngClass]="{ 'font-weight-bold': isFirst }" *ngFor="let category of option.categoriesAndLabel ; let isFirst = first">{{ category | translate }}</span>
  </div>
  <div app-links-item-content-option class="d-flex align-items-center">
    <button (click)="onSelect()" type="button" mdbBtn [color]="color" size="sm" class="z-depth-0 d-flex px-2 align-items-center my-0 mr-0 ml-1" style="width: 30px; height: 31px;" mdbWavesEffect>
      <i class="fas fa-fw fa-plus"></i>
    </button>
  </div>
</app-links-item>